import axios from 'axios'
import config from '../config'
import { getDoctorToken } from "../utils"
const saveEmergencyDtrfApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}emergency-dtrf`,
        method: params.mode === "edit" ? "put" : "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        },
    })

    return response

}

export default saveEmergencyDtrfApi